export enum ServiceCaseItemUpdateAction {
  ADD_ITEM = 'ADD_ITEM',               // item is added or quantity is increased
  DELETE_ITEM = 'DELETE_ITEM',         // item is removed or quantity is reduced
  REMAIN_ITEM = 'REMAIN_ITEM'          // internal use only: items quantity remains the same
}
